
import { defineComponent, ref } from 'vue'

interface NavLink {
  label: string
  path?: string
  isHome?: boolean
  hash?: string
  children?: NavLink[]
}

export default defineComponent({
  name: 'MainNavigation',
  setup() {
    const isHovered = ref('')
    const dropdownOpen = ref(false)

    return {
      isHovered,
      dropdownOpen,
    }
  },
  methods: {
    getNavLinks(): NavLink[] {
      return [
        {
          label: this.$t('navigation.partner'),
          path: '/',
        },
        {
          label: this.$t('navigation.arbitrary'),
          path: '/media-buying',
        },
        {
          label: this.$t('navigation.career'),
          path: '/career',
        },
        {
          label: this.$t('navigation.services'),
          children: [
            {
              label: 'MT ClickBait',
              path: '/services/mt-clickbait',
            },
            {
              label: 'MT Agency',
              path: '/services/mt-agency',
            },
            {
              label: 'MT Shop',
              path: '/services/mt-shop',
            },
          ],
        },
      ]
    },
    isLinkActive(link: NavLink): boolean {
      let isLinkActive = link.path === this.$route.path

      if (this.isHovered === link.label) isLinkActive = true

      if (link.hash && link.hash !== this.$route.hash) {
        isLinkActive = false
      }

      if (this.$route.hash && link.hash !== this.$route.hash) {
        isLinkActive = false
      }

      return isLinkActive
    },
    getLinkClass(label: string) {
      switch (label) {
        case 'MT ClickBait':
          return 'mt-clickbait'
        case 'MT Agency':
          return 'mt-agency'
        case 'MT Shop':
          return 'mt-shop'
        default:
          return ''
      }
    },
    getServiceColorClass(link: NavLink): string {
      if (link.children && link.children.length > 0) {
        for (let child of link.children) {
          if (this.isLinkActive(child)) {
            console.log(child.label)
            switch (child.label) {
              case 'MT ClickBait':
                return 'active-clickbait'
              case 'MT Agency':
                return 'active-agency'
              case 'MT Shop':
                return 'active-shop'
              default:
                return ''
            }
          }
        }
      }
      return ''
    },
  },
})
